import { LoadingScreen } from "@flat-ui";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useToast } from "@hooks/use-toast";
import { SettingsTabs } from "@router/route-params";
import { HAS_CREDIT_PURCHASED } from "@src/constants/credit-constants";
import { selectedSdbCompanyIdSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useEffect } from "react";

/**
 * It is a test component that simulates a successful credit purchase.
 * Renders a success page after purchasing credits.
 * Displays a success message and navigates to the subscription settings page.
 */
export function CreditsPurchaseRedirection(): JSX.Element {
  const { showToast } = useToast();
  const { trackEvent } = useTrackEvent();
  const { navigateToSettingsPage } = useAppNavigation();
  const companyId = useAppSelector(selectedSdbCompanyIdSelector);

  useEffect(() => {
    localStorage.setItem(HAS_CREDIT_PURCHASED, "true");

    // Track the event when the user get redirected to application after purchasing credits
    trackEvent({
      name: WorkspaceEvents.purchaseCreditsSuccess,
    });

    if (companyId) {
      navigateToSettingsPage({
        companyId,
        settingsTab: SettingsTabs.subscription,
      });
    }
  }, [companyId, navigateToSettingsPage, showToast, trackEvent]);

  return <LoadingScreen />;
}
